<header class="header-bold mt-0 mb-0 p-3 pt-5">
    <div class="center-layout">
      <h1>Terms and Conditions</h1>
    </div>
  </header>
  <div class="main-content cta-container center-layout" *ngIf="program">
    <div [innerHTML]="program.termsAndConditions || '' | safeHtml"></div>
    <div>
      <sp-button [btn]="btn.Primary" (onClick)="continue()" extraClasses="terms-btn">
        Continue
      </sp-button>
    </div>
  </div>